import { NEW_DASHBOARD_ENDPOINT } from 'constants/apis';

import { getAnalyticsSetToShare } from 'selectors/dashboards/dashboard-hub';

import {
  AnalyticsListActionCreatorArgs,
  AnalyticsListResultsCollation,
} from '../../analytics-config';

import { campaignAnalyticsActionCreator } from './analytics-campaign-reducer';
import { recentlyViewedAnalyticsActionCreator } from './analytics-last-viewed-reducer';
import { processAnalyticResults } from './analytics-list-reducer';
import { updateDashboardsWithId } from './analytics-owned-reducer';
import { sidebarAnalyticsActionCreator } from './analytics-sidebar-reducer';

export const LIST_STARRED_ANALYTICS = 'analytics/LIST_STARRED_ANALYTICS';
export const LIST_STARRED_ANALYTICS_SUCCESS =
  'analytics/LIST_STARRED_ANALYTICS_SUCCESS';
export const LIST_STARRED_ANALYTICS_ERROR =
  'analytics/LIST_STARRED_ANALYTICS_ERROR';
export const SET_SHARED_STARRED_ANALYTICS =
  'analytics/SET_SHARED_STARRED_ANALYTICS';

export const RESET = 'analytics/RESET_STARRED_ANALYTICS_STATE';

export const UPDATE_TITLE_STARRED_ANALYTICS =
  'analytics/UPDATE_TITLE_STARRED_ANALYTICS';

export const initialState = {
  error: false,
  loading: true,
  listFilters: {
    filtering: false,
    search: '',
  },
  items: [],
  paginationCount: null,
  ownerFilterAnalytics: [],
  resultsCollation: {
    pageNumber: 1,
    sort: 'lastUpdated',
    sortDirection: 'desc',
    ownerFilter: 'all',
  } as AnalyticsListResultsCollation,
};

const starredAnalyticReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_STARRED_ANALYTICS:
      return {
        ...state,
        loading: true,
        listFilters: {
          ...state.listFilters,
          filtering: false,
        },
        error: null,
      };
    case LIST_STARRED_ANALYTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        listFilters: {
          filtering: action.payload.filtering,
          search: action.payload.search,
        },
        error: null,
        items: action.payload.appendItems
          ? [...state.items, ...action.payload.items]
          : action.payload.items,
        paginationCount: action.payload.paginationCount,
        ownerFilterAnalytics: action.payload.isFilter
          ? state.ownerFilterAnalytics
          : action.payload.items,
        resultsCollation: action.payload.resultsCollation,
      };
    case LIST_STARRED_ANALYTICS_ERROR:
      return {
        ...state,
        loading: false,
        listFilters: {
          ...state.listFilters,
          filtering: false,
        },
        error: action.payload.error,
      };
    case SET_SHARED_STARRED_ANALYTICS:
      return {
        ...state,
        items: getAnalyticsSetToShare({
          analytics: state.items,
          isShared: action.payload.isShared,
          idsToCheckForSharing: action.payload.analyticIds,
        }),
      };

    case RESET:
      return {
        ...initialState,
      };
    case UPDATE_TITLE_STARRED_ANALYTICS:
      return {
        ...state,
        items: updateDashboardsWithId(
          state.items,
          action.payload.dashboardId,
          action.payload.newTitle,
        ),
      };
    default:
      return state;
  }
};

export const resetStarredAnalyticsList = () => ({
  type: RESET,
});

export const starredAnalyticsActionCreator = ({
  endpointBase = NEW_DASHBOARD_ENDPOINT,
  search = null,
  ownerId = null,
  isAlreadyFiltered = false,
  resultsCollation = initialState.resultsCollation,
  campaigns,
  isInitialLoad = false,
  doCountReload = false,
  appendItems = false,
}: AnalyticsListActionCreatorArgs = {}) => async dispatch => {
  const params = {
    ...resultsCollation,
    starredOnly: true,
    search,
    ownerId,
    campaigns,
  };

  const isFilter = !!search || !!ownerId;
  dispatch({ type: LIST_STARRED_ANALYTICS });

  try {
    const actionCreatorArgs = {
      endpointBase,
      isAlreadyFiltered: isFilter,
    };
    const { items, itemCount } = await processAnalyticResults({
      params,
      endpointBase,
    });

    dispatch({
      type: LIST_STARRED_ANALYTICS_SUCCESS,
      payload: {
        items: items,
        appendItems,
        paginationCount: itemCount,
        filtering: isAlreadyFiltered || isFilter,
        search,
        isFilter,
        resultsCollation,
      },
    });

    dispatch(
      sidebarAnalyticsActionCreator({
        endpointBase,
        doCountReload,
      }),
    );
    if (isInitialLoad) {
      dispatch(recentlyViewedAnalyticsActionCreator(actionCreatorArgs));
      dispatch(campaignAnalyticsActionCreator(actionCreatorArgs));
    }
  } catch (e) {
    dispatch({
      type: LIST_STARRED_ANALYTICS_ERROR,
      payload: {
        error: e.response?.data,
      },
    });
  }
};

export default starredAnalyticReducer;
